<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.name" placeholder="公司/联系人/电话/银行卡" />
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button type="primary" size="small" class="text-font-sm" @click="createData"><Icon type="md-add" /> 添加公司</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                </div>
                            </div>

                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" :data="dataList.data" no-data-text="暂无数据记录">
                                <template #company="{ row }">
                                    <div class="d-width cursor text-primary" :title="row.company">
                                        <span>{{row.company}}</span>
                                    </div>
                                </template>
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 1" color="blue" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 3" color="green" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 2" color="red" :text="row.status_name" />
                                    <Badge v-else color="#999999" text="其他" />
                                </template>
                                <template #action="{ row, index }">
                                    <a class="text-font-sm text-primary"  @click="editData(row.id)">编辑</a>
                                    <Divider type="vertical" />
                                    <a class="text-font-sm text-danger" @click="deleteData(row.id, index)">删除</a>
                                </template>
                            </Table>
                            <div class="em-page em-flex">
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="saveData"></add-modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "./CreateCompany";
import {deleteInvoiceCompany, getInvoiceCompanyList} from "@/apis/invoice/company";
export default {
    name: "InvoiceCompany",
    components: {
        Headers, Side, AddModal
    },
    data () {
        return {
            search: {
                name: ''
            },
            page : 1,
            pageSize : 15,
            selectCount  : 0,
            dataList : [],
            columns: [
                {
                    title: '公司名称',
                    key: 'company',
                    slot: 'company',
                    minWidth : 200
                },
                {
                    title: '联系人',
                    key: 'real_name'
                },
                {
                    title: '联系电话',
                    key: 'mobile'
                },
                {
                    title: '开户银行',
                    key: 'bank'
                },
                {
                    title: '银行账号',
                    key: 'account'
                },
                {
                    title: '公司地址',
                    key: 'address'
                },
                {
                    title: '状态',
                    key: 'status',
                    slot: 'status',
                    width: 120
                },
                {
                    title: '',
                    key: 'action',
                    slot : 'action',
                    // align: 'center',
                    fixed : 'right',
                    width : 110
                }
            ],
            is_create : false

        }
    },
    created(){
        this.getList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {
        /**
         功能：
         time: 2026/1/6 15:14
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        /**
         功能：
         time: 2026/1/6 15:14
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                name: ''
            };
            that.getList();
        },
        /**
         功能：列表
         time: 2025-09-01 18:09:28
         **/
        getList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getInvoiceCompanyList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         功能：分页
         time: 2025-54-03 09:54:43
         **/
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },

        /**
         功能：
         time: 2026/1/7 10:05
         **/
        createData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         功能：
         time: 2026/1/7 10:05
         **/
        editData(id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(id);
            })
        },
        /**
         功能：操作返回
         time: 2025-26-02 09:26:53
         **/
        saveData(){
            let that = this;
            that.getList();
        },
        /**
         功能：
         time: 2026/1/7 10:04
         **/
        deleteData(inv_id, index){
            let that = this;
            if(!inv_id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除记录',
                content: '此操作将删除记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteInvoiceCompany(inv_id).then( e =>{
                        that.dataList.data.splice(index , 1);
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                    })
                },
                onCancel: () => {}
            });
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
